var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseButton',_vm._b({on:{"click":function($event){return _vm.$emit('click')}}},'BaseButton',{ label: _vm.label, actionLabel: _vm.actionLabel, showIcon: _vm.showIcon, icon: _vm.icon, type: _vm.type, size: _vm.size, enabled: _vm.enabled, processing: _vm.saving},false))
}
var staticRenderFns = []

export { render, staticRenderFns }